import { Avatar } from "@mui/material";

export const COLUMNS = [
  
    {
        header: "Department Name",
        accessor: "name",
    }
]